// extracted by mini-css-extract-plugin
export default {"ShadowData":"styles_ShadowData__h9t45","ShadowDataItem":"styles_ShadowDataItem__SBd8C"};